import React from 'react';
const PastAisteQuestions = {
  "2024": [
    "Cumhacht na meán sóisialta",
    "An bhfuil saol maith ag gach duine i sochaí an lae inniu?",
    "Éire agus cúrsaí idirnáisiúnta",
    "An pléisiúr agus an briseadh croí a bhaineann leis an spórt",
    "An saol faoin tuath, mar atá agus mar a bheidh"
  ],

  "2023": [
    "An costas maireachtála in Éirinn",
    "Fadhb na ndrugaí sa lá atá inniu ann",
    "Daoine cáiliúla i saol an lae inniu",
    "An éagóir i saol an lae inniu",
    "Na rudaí a chuireann isteach ar shláinte an duine"
  ],

  "2022": [
    "Sochaí na hÉireann sa lá atá inniu ann",
    "An tionchar a bhíonn ag na meáin shóisialta ar dhaoine",
    "Éire agus an tAontas Eorpach",
    "Saol an duine óig in Éirinn – an bhfuil sé ag dul i bhfeabhas nó in olcas?",
    "Mo laochra"
  ],

  "2021": [
    "Fadhbanna móra na linne seo",
    "Cearta Daonna",
    "An tAthrú Aeráide",
    "An Ghaeilge agus an cultúr Gaelach",
    "Buntáistí agus míbhuntáistí na teicneolaíochta"
  ],

  "2020": [
    "An choiriúlacht i saol an lae inniu",
    "Scéalta nuachta an lae inniu",
    "Na cúiseanna móra imní atá ag daoine óga faoi láthair",
    "An saol a bhíonn ag inimircigh in Éirinn",
    "An teicneolaíocht i saol an lae inniu"
  ]
};

export default PastAisteQuestions;